(function () {
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function initLiveShopping(root) {
    // Oculta el título de la página que pone Shopify automáticamente
    // (el texto en fondo blanco arriba) — no es parte de esta sección,
    // así que lo escondemos desde aquí, junto con todo su contenedor
    // (para no dejar el espacio en blanco vacío).
    var pageTitle = document.querySelector('#MainContent h1, main h1');
    if (pageTitle) {
      var titleSection = pageTitle.closest('.shopify-section') || pageTitle.closest('section') || pageTitle.parentElement;
      if (titleSection) {
        titleSection.style.display = 'none';
      } else {
        pageTitle.style.display = 'none';
      }
    }

    var statusIcon = root.querySelector('[data-live-status-icon]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-live-item]'));
    var featuredBox = root.querySelector('[data-live-featured-content]');
    var featuredMeta = root.querySelector('[data-live-featured-meta]');
    var videoBox = root.querySelector('[data-live-video]');
    var placeholder = root.querySelector('[data-youtube-frame]');
    var gate = root.querySelector('[data-live-gate]');
    var gateBtn = root.querySelector('[data-live-gate-btn]');
    var fullscreenBtn = root.querySelector('[data-live-fullscreen-btn]');
    var closeBtn = root.querySelector('[data-live-close-btn]');
    var overlayProduct = root.querySelector('[data-live-overlay-product]');
    var overlayChatBox = root.querySelector('[data-live-overlay-chat]');
    var chatInputEl = root.querySelector('[data-live-chat-input]');
    var ytPlayer = null;
    var hasEnteredLive = false;
    var supportsNativeFullscreen = !!(videoBox && (videoBox.requestFullscreen || videoBox.webkitRequestFullscreen));

    // --- Conexión a Firebase (se inicializa aquí arriba porque el
    // video puede necesitar el link que se ponga en el panel de
    // control, no solo el que quedó fijo en la configuración) ---
    var db = null;
    if (window.firebase && window.firebaseConfig) {
      if (!firebase.apps.length) firebase.initializeApp(window.firebaseConfig);
      db = firebase.database();
    }

    // --- Agregar al carrito ---
    function addToCart(variantId, button) {
      if (!variantId) return;
      button.disabled = true;
      var originalText = button.textContent;
      button.textContent = 'Agregando…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo agregar');
          return res.json();
        })
        .then(function () {
          button.textContent = '✓ Agregado';
          button.classList.add('is-added');
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () {
            button.textContent = originalText;
            button.classList.remove('is-added');
            button.disabled = false;
          }, 2000);
        })
        .catch(function () {
          button.textContent = 'Error, intenta de nuevo';
          button.disabled = false;
        });
    }

    // --- Comprar ahora ---
    function buyNow(variantId, button) {
      if (!variantId) return;
      var originalText = button.textContent;
      button.disabled = true;
      button.textContent = 'Redirigiendo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo agregar');
          window.location.href = '/checkout';
        })
        .catch(function () {
          button.textContent = 'Error, intenta de nuevo';
          button.disabled = false;
          setTimeout(function () { button.textContent = originalText; }, 2000);
        });
    }

    items.forEach(function (item) {
      var addBtn = item.querySelector('[data-live-add]');
      var variantId = item.dataset.variantId;
      addBtn.addEventListener('click', function () {
        addToCart(variantId, addBtn);
      });
    });

    // --- Producto destacado (viene de Firebase, lo llena el panel de control) ---
    function stockHtml(data, cssPrefix) {
      if (data.available === undefined) return '';
      return data.available
        ? '<p class="' + cssPrefix + '-stock is-available">✅ Disponible</p>'
        : '<p class="' + cssPrefix + '-stock is-out">❌ Agotado</p>';
    }

    function renderFeaturedFromData(data) {
      if (!data) return;

      items.forEach(function (i) {
        i.classList.toggle('is-featured', i.dataset.productId === data.productId);
      });

      featuredBox.innerHTML =
        (data.image ? '<img src="' + data.image + '" alt="' + escapeHtml(data.title) + '">' : '') +
        '<div class="live-shopping__featured-info">' +
        '<p class="live-shopping__featured-title">' + escapeHtml(data.title) + '</p>' +
        '<p class="live-shopping__featured-price">' + escapeHtml(data.price) + '</p>' +
        '</div>' +
        '<button type="button" class="live-shopping__featured-add">Agregar</button>';

      featuredBox.querySelector('.live-shopping__featured-add').addEventListener('click', function (e) {
        addToCart(data.variantId, e.currentTarget);
      });

      if (featuredMeta) {
        featuredMeta.innerHTML =
          '<button type="button" class="live-shopping__buy-now" data-buy-now>Comprar ahora</button>' +
          stockHtml(data, 'live-shopping__') +
          (data.optionsText ? '<p class="live-shopping__variant-text">' + escapeHtml(data.optionsText) + '</p>' : '');

        var buyBtn = featuredMeta.querySelector('[data-buy-now]');
        if (buyBtn) buyBtn.addEventListener('click', function () { buyNow(data.variantId, buyBtn); });
      }

      if (overlayProduct) {
        overlayProduct.hidden = false;
        overlayProduct.innerHTML =
          (data.image ? '<img src="' + data.image + '" alt="">' : '') +
          '<div class="live-shopping__overlay-product-info">' +
          '<p class="live-shopping__overlay-product-title">' + escapeHtml(data.title) + '</p>' +
          '<p class="live-shopping__overlay-product-price">' + escapeHtml(data.price) + '</p>' +
          '<div class="live-shopping__overlay-product-buttons">' +
          '<button type="button" class="live-shopping__overlay-buy" data-overlay-buy>Comprar ahora</button>' +
          '<button type="button" class="live-shopping__overlay-add" data-overlay-add>Agregar</button>' +
          '</div>' +
          '<p class="live-shopping__overlay-product-meta">' +
          (data.available === false ? '<span class="is-out">Agotado</span>' : data.available === true ? 'Disponible' : '') +
          (data.optionsText ? ' · ' + escapeHtml(data.optionsText) : '') +
          '</p>' +
          '</div>';

        overlayProduct.querySelector('[data-overlay-buy]').addEventListener('click', function (e) {
          buyNow(data.variantId, e.currentTarget);
        });
        overlayProduct.querySelector('[data-overlay-add]').addEventListener('click', function (e) {
          addToCart(data.variantId, e.currentTarget);
        });
      }
    }

    // --- Video de YouTube: usa el que esté puesto en Firebase (desde
    // el panel de control) si existe; si no, el de la configuración
    // fija de la sección como respaldo inicial. ---
    if (placeholder) {
      var videoId = placeholder.dataset.youtubeId;
      var playerReady = false;

      function createPlayer(idToUse) {
        ytPlayer = new YT.Player(placeholder, {
          videoId: idToUse,
          playerVars: {
            autoplay: 1,
            mute: 1,
            playsinline: 1,
            controls: 0,
            modestbranding: 1,
            rel: 0,
            iv_load_policy: 3,
            disablekb: 1,
            fs: 0,
            enablejsapi: 1,
            origin: window.location.origin
          },
          events: {
            onReady: function () {
              playerReady = true;
              var frame = videoBox.querySelector('iframe');
              if (frame) {
                frame.classList.add('is-cropped');
                setTimeout(function () { frame.classList.remove('is-cropped'); }, 7000);
              }
            }
          }
        });
      }

      function loadYouTubeApiAndCreate(idToUse) {
        if (window.YT && window.YT.Player) {
          createPlayer(idToUse);
        } else {
          var apiScript = document.createElement('script');
          apiScript.src = 'https://www.youtube.com/iframe_api';
          document.head.appendChild(apiScript);
          window.onYouTubeIframeAPIReady = function () { createPlayer(idToUse); };
        }
      }

      if (db) {
        db.ref('liveShopping/youtubeId').once('value', function (snap) {
          var firebaseId = snap.val();
          loadYouTubeApiAndCreate(firebaseId || videoId);
        });

        // Si el vendedor pone un link nuevo mientras la página ya está
        // abierta, cambiamos el video sin necesitar recargar.
        db.ref('liveShopping/youtubeId').on('value', function (snap) {
          var newId = snap.val();
          if (playerReady && newId && ytPlayer && ytPlayer.getVideoData) {
            var current = ytPlayer.getVideoData();
            if (current && current.video_id !== newId) {
              ytPlayer.loadVideoById(newId);
              ytPlayer.mute();
            }
          }
        });
      } else {
        loadYouTubeApiAndCreate(videoId);
      }

      if (gateBtn) {
        gateBtn.addEventListener('click', function () {
          function proceedIfLive(isLive) {
            if (isLive === false) {
              showEndedScreen();
              return;
            }
            hasEnteredLive = true;
            if (ytPlayer) {
              ytPlayer.unMute();
              ytPlayer.playVideo();
            }
            gate.classList.add('is-hidden');
            if (fullscreenBtn) fullscreenBtn.hidden = false;
          }

          if (db) {
            db.ref('liveShopping/isLive').once('value', function (snap) {
              proceedIfLive(snap.val());
            });
          } else {
            proceedIfLive(true);
          }
        });
      }
    }

    // --- Pantalla de "live terminado": se muestra al tocar "Entrar al
    // Live" si no hay transmisión activa, o en cualquier momento si el
    // vendedor termina la transmisión mientras alguien ya la está
    // viendo. ---
    var endedScreen = root.querySelector('[data-live-ended]');
    var endedReturns = root.querySelector('[data-live-ended-returns]');

    function showEndedScreen() {
      if (ytPlayer && ytPlayer.stopVideo) ytPlayer.stopVideo();
      if (gate) gate.classList.add('is-hidden');
      if (endedScreen) endedScreen.hidden = false;

      if (featuredBox) featuredBox.innerHTML = '<p class="live-shopping__featured-empty">La transmisión terminó.</p>';
      if (featuredMeta) featuredMeta.innerHTML = '';
      if (overlayProduct) {
        overlayProduct.hidden = true;
        overlayProduct.innerHTML = '';
      }

      videoBox.classList.remove('is-fullscreen');
      var exit = document.exitFullscreen || document.webkitExitFullscreen;
      if (document.fullscreenElement && exit) exit.call(document);
      document.documentElement.classList.remove('live-shopping-locked');
      document.body.classList.remove('live-shopping-locked');

      if (db) {
        db.ref('liveShopping/returnsAt').once('value', function (snap) {
          var returnsAt = snap.val();
          if (endedReturns) {
            if (returnsAt) {
              var d = new Date(returnsAt);
              var formatted = isNaN(d.getTime())
                ? returnsAt
                : d.toLocaleString('es-MX', { dateStyle: 'long', timeStyle: 'short' });
              endedReturns.textContent = 'Vuelve: ' + formatted;
            } else {
              endedReturns.textContent = '';
            }
          }
        });
      }
    }

    // --- Pantalla completa: SOLO nativa. Si no está disponible o falla,
    // simplemente no se ofrece (el botón ni siquiera se muestra). ---
    if (fullscreenBtn && videoBox) {
      fullscreenBtn.addEventListener('click', function () {
        var request = videoBox.requestFullscreen || videoBox.webkitRequestFullscreen;
        var nativeConfirmed = false;

        function activateManualFullscreen() {
          if (nativeConfirmed) return; // la nativa sí entró, no hace falta la manual
          videoBox.classList.add('is-fullscreen');
          fullscreenBtn.hidden = true;
          if (closeBtn) closeBtn.hidden = false;
          document.documentElement.classList.add('live-shopping-locked');
          document.body.classList.add('live-shopping-locked');
        }

        if (request) {
          try {
            var result = request.call(videoBox);
            if (result && result.catch) {
              result.catch(activateManualFullscreen);
            }
          } catch (e) {
            activateManualFullscreen();
          }
          // Si en 300ms la nativa no se confirmó de verdad, usamos la
          // manual como respaldo (para navegadores como iPhone que no
          // la soportan pero tampoco siempre avisan del error).
          setTimeout(function () {
            var isNativeActive = document.fullscreenElement === videoBox || document.webkitFullscreenElement === videoBox;
            if (isNativeActive) {
              nativeConfirmed = true;
              fullscreenBtn.hidden = true;
              if (closeBtn) closeBtn.hidden = false;
            } else {
              activateManualFullscreen();
            }
          }, 300);
        } else {
          activateManualFullscreen();
        }
      });
    }

    // Si sale de la pantalla completa NATIVA con el botón propio del
    // sistema (o el gesto de "atrás"), sincronizamos nuestros botones.
    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (evt) {
      document.addEventListener(evt, function () {
        var isNativeActive = document.fullscreenElement === videoBox || document.webkitFullscreenElement === videoBox;
        if (!isNativeActive && !videoBox.classList.contains('is-fullscreen')) {
          if (closeBtn) closeBtn.hidden = true;
          if (fullscreenBtn) fullscreenBtn.hidden = false;
          document.documentElement.classList.remove('live-shopping-locked');
          document.body.classList.remove('live-shopping-locked');
        }
      });
    });

    if (closeBtn && videoBox) {
      closeBtn.addEventListener('click', function () {
        var exit = document.exitFullscreen || document.webkitExitFullscreen;
        if (document.fullscreenElement && exit) {
          exit.call(document);
        }
        videoBox.classList.remove('is-fullscreen');
        closeBtn.hidden = true;
        if (fullscreenBtn) fullscreenBtn.hidden = false;
        document.documentElement.classList.remove('live-shopping-locked');
        document.body.classList.remove('live-shopping-locked');
      });
    }

    // --- Chat por encima del teclado: usamos el evento real de
    // foco/desenfoque del campo (focus/blur), que SIEMPRE se dispara
    // sin importar cómo se cierre el teclado — mucho más confiable que
    // intentar medir el tamaño de la pantalla. ---
    function keyboardOffset() {
      if (!window.visualViewport) return 0;
      var kh = window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop;
      return kh > 0 ? kh : 0;
    }

    if (chatInputEl && overlayChatBox) {
      chatInputEl.addEventListener('focus', function () {
        // Reforzamos el bloqueo del fondo justo al enfocar — Safari a
        // veces "empuja" toda la pantalla (incluso elementos fijos) al
        // abrir el teclado, así que insistimos en mantenerlo bloqueado.
        document.documentElement.classList.add('live-shopping-locked');
        document.body.classList.add('live-shopping-locked');

        if (overlayProduct) overlayProduct.style.display = 'none';

        overlayChatBox.style.transform = 'translateY(-' + keyboardOffset() + 'px)';
        // El teclado tarda un poco en animar, así que reajustamos varias
        // veces mientras termina de aparecer.
        [50, 150, 300, 500, 800].forEach(function (delay) {
          setTimeout(function () {
            document.documentElement.classList.add('live-shopping-locked');
            document.body.classList.add('live-shopping-locked');
            window.scrollTo(0, 0);
            overlayChatBox.style.transform = 'translateY(-' + keyboardOffset() + 'px)';
          }, delay);
        });
      });

      chatInputEl.addEventListener('blur', function () {
        overlayChatBox.style.transform = '';
        if (overlayProduct) overlayProduct.style.display = '';
        [50, 150, 300, 500].forEach(function (delay) {
          setTimeout(function () { window.scrollTo(0, 0); }, delay);
        });
      });
    }

    // --- Firebase: producto destacado en tiempo real + chat ---
    if (db) {
      db.ref('liveShopping/current').on('value', function (snapshot) {
        var data = snapshot.val();
        if (data) renderFeaturedFromData(data);
      });

      var chatMessagesBox = root.querySelector('[data-live-chat-messages]');
      var chatForm = root.querySelector('[data-live-chat-form]');
      var chatInput = root.querySelector('[data-live-chat-input]');

      function getGuestName() {
        var saved = localStorage.getItem('liveShoppingGuestName');
        if (saved) return saved;
        var name = window.prompt('¿Cómo te llamas? (para el chat)', '') || 'Invitado';
        name = name.trim().slice(0, 20) || 'Invitado';
        localStorage.setItem('liveShoppingGuestName', name);
        return name;
      }

      // --- ID único por navegador (persiste aunque cierres y vuelvas a
      // entrar) + número secuencial asignado la primera vez que se
      // registra, usando una transacción para que nunca se repita. ---
      function getGuestId() {
        var saved = localStorage.getItem('liveShoppingGuestId');
        if (saved) return saved;
        var id = 'u-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
        localStorage.setItem('liveShoppingGuestId', id);
        return id;
      }

      var guestId = getGuestId();
      var guestNumber = null;
      var isMuted = false;
      var isBanned = false;

      function registerGuest() {
        var userRef = db.ref('liveShopping/users/' + guestId);
        userRef.once('value', function (snapshot) {
          var existing = snapshot.val();
          if (existing && existing.number) {
            guestNumber = existing.number;
          } else {
            // Asigna el siguiente número disponible de forma segura,
            // aunque varias personas se unan al mismo tiempo.
            db.ref('liveShopping/userCounter').transaction(function (current) {
              return (current || 0) + 1;
            }, function (error, committed, snap) {
              if (committed) {
                guestNumber = snap.val();
                userRef.set({ number: guestNumber, name: getGuestName(), muted: false, banned: false });
              }
            });
          }
        });

        // Escucha en tiempo real si te silencian o banean
        userRef.on('value', function (snapshot) {
          var data = snapshot.val();
          if (!data) return;
          isMuted = !!data.muted;
          isBanned = !!data.banned;
          if (chatInput) {
            if (isBanned) {
              chatInput.disabled = true;
              chatInput.placeholder = 'Fuiste bloqueado del chat';
            } else if (isMuted) {
              chatInput.disabled = true;
              chatInput.placeholder = 'Un moderador silenció tus mensajes';
            } else {
              chatInput.disabled = false;
              chatInput.placeholder = 'Escribe un mensaje…';
            }
          }
        });
      }
      registerGuest();

      if (chatMessagesBox) {
        db.ref('liveShopping/chat').limitToLast(3).on('value', function (snapshot) {
          var messages = [];
          snapshot.forEach(function (child) { messages.push(child.val()); });
          chatMessagesBox.innerHTML = messages.map(function (m) {
            return (
              '<div class="live-shopping__overlay-message">' +
              '<strong>' + escapeHtml(m.name) + ':</strong>' +
              escapeHtml(m.text) +
              '</div>'
            );
          }).join('');
        });
      }

      if (chatForm && chatInput) {
        chatForm.addEventListener('submit', function (e) {
          e.preventDefault();
          if (isBanned || isMuted) return;
          var text = chatInput.value.trim();
          if (!text) return;
          db.ref('liveShopping/chat').push({
            name: getGuestName(),
            text: text,
            userId: guestId,
            number: guestNumber,
            ts: firebase.database.ServerValue.TIMESTAMP
          });
          chatInput.value = '';
        });
      }

      // --- Si el vendedor termina la transmisión MIENTRAS alguien ya
      // la está viendo: se detiene todo automáticamente. Si la persona
      // TODAVÍA no ha tocado "Entrar al Live", no hacemos nada aquí —
      // eso se revisa hasta que toque el botón (ver arriba). ---
      db.ref('liveShopping/isLive').on('value', function (snapshot) {
        var isLive = snapshot.val();

        if (statusIcon) statusIcon.classList.toggle('is-live', isLive === true);

        if (isLive === false && hasEnteredLive) {
          showEndedScreen();
          if (chatMessagesBox) chatMessagesBox.innerHTML = '';
          if (chatInput) {
            chatInput.disabled = true;
            chatInput.placeholder = 'La transmisión terminó';
          }
        } else if (isLive !== false && endedScreen && !endedScreen.hidden) {
          endedScreen.hidden = true;
          if (chatInput) {
            chatInput.disabled = false;
            chatInput.placeholder = 'Escribe un mensaje…';
          }
        }
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-live-shopping]').forEach(initLiveShopping);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
